// Appends a <style>, filled with custom CSS, to the head section
const setCustomStyles = customStyles => {
    if (customStyles === undefined || !customStyles) return;
    // const head = document.head;

    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(customStyles));

    document.head.appendChild(style);
};

export default setCustomStyles;
